module.exports = __webpack_public_path__ + "assets/img/title-66f62267.png";